import notify from 'components/atoms/Notify'
import isEmpty from 'lodash/isEmpty'
import { parseCookies } from 'nookies'
import refreshToken from './refreshToken'

const baseUrl = process.env.REACT_APP_BASE_URL

const apiPut = async (query, formData, retryCount = 0) => {
  const { accessToken } = parseCookies()

  const isFormData = formData instanceof FormData

  const config = {
    method: 'PUT',
    body: isFormData ? formData : JSON.stringify(formData),
  }

  if (!isFormData) {
    config.headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }
  }

  if (!isEmpty(accessToken)) {
    config.headers = {
      Authorization: accessToken,
      ...config.headers,
    }
  }

  const response = await fetch(`${baseUrl}/admin/${query}`, config)
  const responseData = await response.json()

  if (response.status === 403 && retryCount === 0) {
    const refreshed = await refreshToken()
    if (refreshed) {
      return apiPut(query, formData, retryCount + 1)
    } else {
      notify.error(responseData.message || 'Session expired. Please login again.', null, responseData.err)
      return responseData
    }
  }

  if (!responseData.success) {
    notify.error(responseData.message, null, responseData.err)
  }
  return responseData
}

export default apiPut
